module.exports = __webpack_public_path__ + "assets/img/lobby_bonuses.f03968d4.png";